import {
  PartnerPreferenceType,
  PartnerType,
} from '@client/graphql/__generated__/types';

export interface RosterAgent {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface RosterPreference {
  id: string;
  partnerType: PartnerType;
  preferenceType: PartnerPreferenceType;
  partner: { id: string; name: string } | null;
  partnerContact: {
    id: string;
    firstName: string;
    lastName: string;
    partner: { id: string; name: string } | null;
  } | null;
}

export interface RosterEntry {
  id: string;
  isContactable: boolean;
  agent: RosterAgent;
  preferences: {
    [PartnerType.LENDER]: RosterPreference | null;
    [PartnerType.TITLE]: RosterPreference | null;
    [PartnerType.INSURANCE]: RosterPreference | null;
  };
}

export const PREFERENCE_TYPE_LABELS: Record<
  PartnerPreferenceType,
  Record<PartnerType, string>
> = {
  [PartnerPreferenceType.SPECIFIC_CONTACT]: {
    [PartnerType.LENDER]: 'Specific Loan Officer',
    [PartnerType.TITLE]: 'Specific Title Agent',
    [PartnerType.INSURANCE]: 'Specific Insurance Agent',
  },
  [PartnerPreferenceType.SET_PER_TRANSACTION]: {
    [PartnerType.LENDER]: 'Set Per Transaction',
    [PartnerType.TITLE]: 'Set Per Transaction',
    [PartnerType.INSURANCE]: 'Set Per Transaction',
  },
  [PartnerPreferenceType.ROTATION]: {
    [PartnerType.LENDER]: 'Rotation',
    [PartnerType.TITLE]: 'Rotation',
    [PartnerType.INSURANCE]: 'Rotation',
  },
};

export const PARTNER_TYPE_LABELS: Record<PartnerType, string> = {
  [PartnerType.LENDER]: 'Preferred Lender',
  [PartnerType.TITLE]: 'Preferred Title',
  [PartnerType.INSURANCE]: 'Preferred Insurance',
};
